import { Component, OnInit } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs/Subscription';

import { AppComponentGenericComponent } from '../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../services/data.service';
import { User } from '../../models/user';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends AppComponentGenericComponent implements OnInit {
	userLoggedSync: Subscription;
	praticheSync: Subscription;
	notificheUtenteDictSync: Subscription;

	userLogged: any = false;
	pratiche: any[] = [];
	notificheUtenteDict: any[] = [];

	//	tab benvenuto
	private headers: HttpHeaders;
	comune: any;
	comuneSync: Subscription;
	meteo: any = {};
	meteo_icon: string = null;
	clock: string;
	clockSync: Subscription;

	//	tab situazione pratiche
	numPraticheTotali: number = 0;
	numPraticheProssimePrescizione: number = 0;
	numPraticheDaGestire: number = 0;
	numPraticheSenzaNotifica: number = 0;
	numPraticheChiuse: number = 0;

	// tab grafico a torta
	colors : any[] = [{backgroundColor: ['#ed5565','#f8ac59','#1c84c6','#1ab394']}];
	public pieChartType: string = 'bar';
	public radarChartType: string = 'doughnut';
	public pieChartLabels: string[] = ['Prossime alla prescrizione', 'Da gestire', 'Senza notifica', 'Chiuse'];
	public pieChartData: number[] = [
		this.numPraticheProssimePrescizione,
		this.numPraticheDaGestire,
		this.numPraticheSenzaNotifica
	];

	constructor(protected dataService: DataService) {
		super(dataService, 'dashboard');
	}

	ngOnInit() {
		this.headers = new HttpHeaders();
		this.userLoggedSync = this.dataService.getUtentiService().userLogged$.subscribe(
			userLogged => {
				this.userLogged = userLogged;
				console.debug('DASHBOARD|userLogged:', this.userLogged, this.dataService.getUtentiService().getUserByComune().userComplete.id);
			});
		this.praticheSync = this.dataService.pratiche$.subscribe(
			pratiche => {
				this.pratiche = pratiche;
				this.calcNumPratiche();
				console.debug('DASHBOARD|pratiche:', this.pratiche);
			});
		this.notificheUtenteDictSync = this.dataService.notificheUtenteDict$.subscribe(
			notificheUtenteDict => {
				this.notificheUtenteDict = notificheUtenteDict;
				console.debug('DASHBOARD|notificheUtente:', this.notificheUtenteDict, this.dataService.getUtentiService().getUserByComune());
			});

		this.comuneSync = this.dataService.getComuniService().comune$.subscribe(
			comune => {
				if(comune){
					this.comune = comune;
					let comune_nome_lungo = this.comune.nome_lungo;
					let comune_nome = this.comune.nome;
					let meteo_api_key = "4533ccc33f0bb3e3d43a0169b908eda8";
					let units = "metric";
					this.dataService.getCommon().getHttpClient().get<any>("http://api.openweathermap.org/data/2.5/weather?lang=it&q="+comune_nome_lungo+"&appid="+meteo_api_key+"&units="+units, { headers: this.headers })
					.map(res => res).subscribe(
						data => {
							this.meteo = data;
							//console.log("METEO", this.meteo);
							this.meteo_icon = data.weather[0].icon;
						}
					);
				}
			}
		);

		this.clockSync = this.dataService.getCommon().getLocale().clock$.subscribe(
			clock => {
				this.clock = clock;
			}
		);
	}

	calcNumPratiche(){
		let parts: any = null;
		let notifica_data_plus_timeout: Date = null;
		let now: Date = null;

		this.numPraticheTotali = 0;
		this.numPraticheProssimePrescizione = 0;
		this.numPraticheDaGestire = 0;
		this.numPraticheSenzaNotifica = 0;
		this.numPraticheChiuse = 0;

		for(let pratica of this.pratiche){
			pratica.stato_id = Number(pratica.stato_id);
			//console.debug("DASHBOARD|pratica", pratica);
			switch(pratica.stato_id){
				case 1:
					this.numPraticheDaGestire++;
					break;
				case 2:
				case 4:
					this.numPraticheChiuse++;
					break;
				case 6:
					this.numPraticheDaGestire++;
					break;
				default:
					if(!pratica.notifica_data){
						this.numPraticheSenzaNotifica++;
					}else{
						let params: any = {
							numero_scadenza: 0,
							notifica_data: new Date(pratica.notifica_data),
							partenza_stato: pratica.stato_id,
							prossimo_stato: 0,
						};
						this.dataService.getScadenzaPerStato(params);
						//console.log("DASHBOARD| params", params);
						now = this.dataService.getCommon().getLocale().toInternetDate();
						notifica_data_plus_timeout = this.dataService.getCommon().getLocale().toInternetDate(String(pratica.scadenza_data));

						if(params.numero_scadenza && now >= notifica_data_plus_timeout){
							this.numPraticheDaGestire++;
						}else{
							this.numPraticheProssimePrescizione++;
						}
					}
			}
			this.numPraticheTotali++;
		}
		//console.debug("DASHBOARD|numPratichePagate", this.numPraticheChiuse);
		//console.debug("DASHBOARD|numPraticheProssimePrescizione", this.numPraticheProssimePrescizione);
		//console.debug("DASHBOARD|numPraticheDaGestire", this.numPraticheDaGestire);
		//console.debug("DASHBOARD|numPraticheSenzaNotifica", this.numPraticheSenzaNotifica);

		this.pieChartData = [
			this.numPraticheProssimePrescizione,
			this.numPraticheDaGestire,
			this.numPraticheSenzaNotifica,
			this.numPraticheChiuse
		];
	}

	public checkNotificheUtente(): boolean {
		let esito = false;
		if(this.notificheUtenteDict[this.dataService.getUtentiService().getUserByComune().userComplete.id])
			if(this.notificheUtenteDict[this.dataService.getUtentiService().getUserByComune().userComplete.id].length)
				esito = true;
		return esito;
	}

	public chartClicked(e: any): void {
		console.debug(e);
	}

	public chartHovered(e: any): void {
		console.debug(e);
	}

	ngOnDestroy() {
		this.userLoggedSync.unsubscribe();
		this.praticheSync.unsubscribe();
		this.notificheUtenteDictSync.unsubscribe()
	}
}
